import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSessions from '../../components/reports/list-sessions.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ReportsSessionsView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_SESSIONS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSessions />
    </AppLayout>
  );
};

export default ReportsSessionsView;
